import { render } from "./StudioList.vue?vue&type=template&id=7e7bd2ed"
import script from "./StudioList.vue?vue&type=script&lang=js"
export * from "./StudioList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__